<template>

    <section class="pt3">
                    <h1 class="standard-title heavy">FAQs</h1>


                    <section class="faq-block" :class="{open: open_blocks.includes('1')}" @click="toggleBlock('1')">
                        <h2 class="standard-title heavy mt2">I'm new / just started. Where should I begin?</h2>
                        <div>

                        <p>Welcome to The Hub. As we&rsquo;ve already created your programme using the quiz option, all you need to do is start the training. Head to your <a href="/dashboard">dashboard</a> and click the button &lsquo;START MY MOVES&rsquo;. This will start your first routine.</p>
                        <p>As soon as you have finished your routine, a green tick ✅ will appear on your calendar. Relax, sit (stand) back and revel in the fact that you&rsquo;ve worked hard and ticked off your first day.</p>
                        <p>We&rsquo;ll see you tomorrow!</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('2')}" @click="toggleBlock('2')">
                        <h2 class="standard-title heavy mt2">Where do I find my programme?</h2>
                        <div>

                        <p>Once you have taken the quiz, we will create a programme for you based on your answers.</p>
                        <p>Here is how to find your programme:</p>
                        <ul>
                            <li>Head to the page &lsquo;<a href="/calendar">view my calendar</a>&rsquo;</li>
                            <li>Toggle to &lsquo;schedule&rsquo; mode</li>
                        </ul>
                        <p>Here you will see your programme for the next 6 months. You can scroll through the days and months to see what routines you’ve done previously & what is upcoming for you.</p>
                        <p>To start your routine each day head to your <a href="/dashboard">dashboard</a> &amp; click &lsquo;start my moves&rsquo;.</p>
                        <p>You can also access your calendar to either check your schedule or your previous routines
                            half way down the main dashboard.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('3')}" @click="toggleBlock('3')">
                        <h2 class="standard-title heavy mt2">How do I join the monthly members&rsquo; call?</h2>
                        <div>

                        <p>We have a members&rsquo; call happening each month where you can:</p>
                        <ul>
                            <li>Ask questions about particular exercises</li>
                            <li>Meet other members</li>
                            <li>Hang out and learn more</li>
                            <li>Enquire about your programme</li>
                            <li>Keep the motivation up</li>
                        </ul>
                        <p>Our members&rsquo; call takes place on zoom and you can join us via any device &amp; from any country.</p>
                        <p>To access the call all members will receive an email towards the end of the month notifying them that a call is upcoming and with a link to register.</p>
                        <p>If you have a question / enquiry and cannot make the call, we will also send a link for you to pre-submit any questions.</p>
                        <p>Roger will answer any pre-submitted questions live on the call, which you will be able to catch up on in the recording. You will find the full recording of the members&rsquo; calls, with relevant time stamps, within The Hub
                            <a href="/workout-library">library</a>.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('4')}" @click="toggleBlock('4')">
                        <h2 class="standard-title heavy mt2">How do I create my own programme?</h2>
                        <div>

                        <p>Through the quiz we will create a programme for you based on the specific answers that you gave; however, you can also do this manually based on your goals, needs, pain points and the length of time you would like your routines.</p>
                        <p>Here are some ideas as to why you would want to create your programme manually:</p>
                        <ul>
                            <li>You have more/less time on a weekend to do a longer/shorter routine</li>
                            <li>Some days for you are busier than others</li>
                            <li>You have pain in a particular area that you would like to deal with first and want to include more routines in that area.</li>
                            <li>There is a very specific goal/area that you would like to work on/achieve</li>
                            <li>You want to try ALL the training and the routines to see what is on offer and what works best for you</li>
                        </ul>
                        <p>All of this is possible and if you would like to create your programme manually, then follow these steps:</p>
                        <ul>
                            <li>Head to your &lsquo;<a href="/private-library">private library</a>&rsquo;</li>
                            <li>Delete all of your current routines using the &lsquo;❌&rsquo; icon</li>
                            <li>Once deleted, head to the page &lsquo;<a href="/calendar">view my calendar</a>&rsquo;</li>
                            <li>Toggle over to &lsquo;schedule&rsquo; mode</li>
                            <li>Click &lsquo;Clear ALL future&rsquo;</li>
                        </ul>
                        <p>Great. You now have an empty calendar and library to create your programme.</p>
                        <p>Your next steps are as follows:</p>
                        <ul>
                            <li>Head to the page &lsquo;<a href="/workout-library">all the videos</a>&rsquo;</li>
                            <li>As you scroll through, click the ⭐️ icon on any video you would like to include in your programme</li>
                            <li>Once you have gone all the way through the list, the ones you have selected will appear in your &lsquo;<a href="/private-library">private
                                library</a>&rsquo;.</li>
                            <li>Now head back to the page &lsquo;<a href="/calendar">view my calendar</a>&rsquo;</li>
                            <li>The list you see next to the calendar is your private library</li>
                            <li>Click on each routine to place it on the day you require</li>
                        </ul>
                        <p>You have the option to:</p>
                        <ul>
                            <li>Move routines to a different day</li>
                            <li>Delete routines from the calendar</li>
                            <li>Scroll through different months</li>
                            <li>Clone previous months</li>
                            <li>Order routines in any way you prefer</li>
                        </ul>
                        <p>On any day you see in your calendar with a 📖 image, you will be following the &lsquo;book moves&rsquo; on video. If you would prefer not to do &lsquo;book moves&rsquo;, you can just replace them with any of your selected routines.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('5')}" @click="toggleBlock('5')">
                        <h2 class="standard-title heavy mt2">How often should I be doing the exercises?</h2>
                        <div>

<p>Consistency beats intensity is our main motto! This is about our long-term movement and how our bodies are moving as we age. For that very reason, we want you to be consistent and build up to making this a daily habit.</p>
<p>At the same time, we also want you to be reasonable and realistic with fitting this around your life. Our recommendation is shorter routines, but daily. As you create that habit and improve on your consistency, you can then start to add longer routines into your programme or retake the quiz according to your new goals.</p>
<p>We also have tools within The Hub to help you keep consistent and on track with how much you are training.</p>
<p>Each day you complete a routine we will mark your calendar with a ✅. This will help you to keep track of days completed and have your own personal target. For each day you complete a routine we will also award you 1 stretch coin. We also give out extra bonus points for 1st, 2nd &amp; 3rd places in our monthly stretch league.</p>
<p>Stretch coins can be used for discounts on merchandise and membership.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('6')}" @click="toggleBlock('6')">
                        <h2 class="standard-title heavy mt2">I&rsquo;d prefer <u>not</u> to follow the book!</h2>
                        <div>

                        <p>When you first joined and took the quiz, you would have been offered the option to either include the &lsquo;book moves&rsquo; or not within your programme.</p>
                        <p>If you choose to include &lsquo;book moves&rsquo; we will alternate your calendar days between &lsquo;book moves&rsquo; &amp; library routines.</p>
                        <p>You can change this by retaking the quiz at any point. This can be done by following these steps:</p>
                        <ul>
                            <li>Head to the page &lsquo;<a href="/calendar">view my calendar</a>&rsquo;</li>
                            <li>Click the button to &lsquo;<a href="/quiz">retake the quiz</a>&rsquo;</li>
                        </ul>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('7')}" @click="toggleBlock('7')">
                        <h2 class="standard-title heavy mt2">I&rsquo;d prefer <u>only</u> to follow the book!</h2>
                        <div>

                        <p>If you’d prefer solely to follow Roger’s book ‘The Flexible Body’ on video & not include any of the routines from the library. You can do that by following these steps.</p>
                        <ul>
                            <li>Head to the page &lsquo;<a href="/calendar">view my calendar</a>&rsquo;</li>
                            <li>Click the button &lsquo;<a href="/quiz">retake the quiz</a>&rsquo;</li>
                        </ul>
                        <p>This will wipe all the library routines from your calendar.</p>

                        <p>Instead of taking the quiz, head to your ‘<a href="/dashboard">dashboard</a>’.</p>

                        <p>You’ll now only be following the moves from ‘The Flexible Body’ book on video. You can also change the intensity of these exercises as you improve on the page ‘<a href="/builder">build my moves</a>’</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('8')}" @click="toggleBlock('8')">
                        <h2 class="standard-title heavy mt2">Should I warm up before doing my routine?</h2>
                        <div>

                        <p>We will automatically populate you with an optional warm-up for the &lsquo;book moves&rsquo;. If for any reason you prefer to skip this, press the &lsquo;&gt;&rsquo; icon on the warm-up video.</p>
                        <p>As a new member you will start on our &lsquo;joint warm-up&rsquo;. If you would prefer our faster paced warm-up, you can change this at any time in your settings.</p>
                        <p>For library routines, as the process is different, we won&rsquo;t offer an optional warm-up first.</p>
                        <p>If however, you would prefer to go through a warm-up beforehand you can always select one of the warm-ups individually from the
                            <a href="/workout-library">library</a>.</p>
                        <p>The majority of exercises we teach are based on slow conscious &amp; controlled movement so whichever exercise you are working on, always match the intensity depending on how that exercise feels for you, no matter the order they come up in. We recommend if you are feeling particularly cold, you should lower the intensity further on your first exercise until you are feeling more warmed up.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('10')}" @click="toggleBlock('10')">
                        <h2 class="standard-title heavy mt2">What&lsquo;s the difference between &lsquo;the library routines&rsquo; &amp; the &lsquo;book moves&rsquo;?</h2>
                        <div>

                        <p>Your daily exercise routines will be created from one of two places.</p>
                        <p>Either:</p>
                        <ul>
                            <li>Roger&rsquo;s book &lsquo;The Flexible Body&rsquo; on video</li>
                            <li>A workout library routine</li>
                        </ul>
                        <p>You can either follow:</p>
                        <ul>
                            <li>Only the book</li>
                            <li>Only the library routines</li>
                            <li>Both together</li>
                        </ul>
                        <p>Our quiz will help you to decide which of the above you choose to follow.</p>
                        <p>Essentially, these are the main differences:</p>
                        <p>If you&rsquo;re following the &lsquo;book moves&rsquo; your routine will:</p>
                        <ul>
                            <li>Have an automatic optional warm-up</li>
                            <li>Always be exactly 10 minutes. 15 minutes including the warm-up</li>
                            <li>Be working on a set of very specific movements</li>
                            <li>Be able to change the intensity of the exercises as you improve on the page &lsquo;<a href="/builder">build
                                my moves</a>&rsquo;</li>
                        </ul>
                        <p>If you&rsquo;re following &lsquo;the library routines&rsquo;, your routine will:</p>
                        <ul>
                            <li>Have no warm-up (You will get warmed up by starting on lighter exercises)</li>
                            <li>Include a larger range of lengths. We have routines from 10 mins up to 1 hour</li>
                            <li>Have a lot more options, ideas and progressions within the routine.</li>
                            <li>Include a much broader range of topics &amp; areas than the book chapters</li>
                        </ul>
                        <p>If you&rsquo;d like to see all of the 9 chapters and 90 exercises from the book head to the page &lsquo;<a href="/chapters">browse
                            the chapters</a>&rsquo;.</p>
                        <p>If you&rsquo;d like to see all of the library routines head to the page &lsquo;<a href="/workout-library">all the
                            videos</a>&rsquo;</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('11')}" @click="toggleBlock('11')">
                        <h2 class="standard-title heavy mt2">How do I increase the difficulty of the exercises in roger&rsquo;s book?</h2>
                        <div>

                        <p>If you&rsquo;re following Rogers book &lsquo;The Flexible Body&rsquo; on video, we will always start you on Level 1 of each chapter. Ie. The exercises with the lowest intensity.</p>
                        <p>Once you&rsquo;re comfortable with any of the exercises and you understand the movement, head to the page &lsquo;<a href="/builder">build
                            my moves</a>&rsquo; where you can change the intensity, per chapter.</p>
                        <p>For example you can level up on the leg flexibility chapter but keep the same intensity on the squat chapter, or vice versa. We refer to this as &lsquo;leveling up&rsquo; or &lsquo;leveling down&rsquo;.</p>
                        <p>The page &lsquo;<a href="/builder">build my moves</a>&rsquo; is only used if you&rsquo;re following exercises from the book.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('12')}" @click="toggleBlock('12')">
                        <h2 class="standard-title heavy mt2">What is leveling up and down?</h2>
                        <div>

                        <p>Leveling up and down only applies to the &lsquo;book moves&rsquo;.</p>
                        <p>Once you have completed your &lsquo;book moves&rsquo; for the day you&rsquo;ll need to make a decision.</p>
                        <p>Here are some questions to help you decide if you should &lsquo;level up&rsquo; (Increase the intensity).</p>
                        <ul>
                            <li>Were any of the exercises not challenging enough?</li>
                            <li>Do you fully understand the movement?</li>
                            <li>Would you like to spend some more time on those exercises?</li>
                        </ul>
                        <p>There is no right or wrong here. It&rsquo;s based on you and how you got along with those particular exercises.</p>
                        <p>You can either:</p>
                        <p>Level up - move to a more challenging exercise for that chapter.</p>
                        <p>Level down - move to a less challenging exercise for that chapter.</p>
                        <p>Leveling up and down is per chapter so you might want to &lsquo;level up&rsquo; in the &lsquo;legs, legs, legs&rsquo; chapter but &lsquo;level down&rsquo; with your hollow body.</p>
                        <p>Note: Leveling down doesn&rsquo;t mean you have failed! </p>
                        <p>There is absolutely nothing wrong with taking your time with an exercise before leveling up. You should make sure you are familiar with the position of the body, how the exercise feels for you and that you can move in it and hold it correctly for the given time.</p>


                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('13')}" @click="toggleBlock('13')">
                        <h2 class="standard-title heavy mt2">When is the right time to level up?</h2>
                        <div>

                        <p>Leveling up and down is only applicable for you if you are following the moves from the book &lsquo;The Flexible Body&rsquo; on video.</p>

                        <p>There are a total of 9 chapters in the book.</p>

                        <p>You&rsquo;ll notice in some chapters it&rsquo;s more obvious when to level up. For example &lsquo;frog stand&rsquo; and &lsquo;headstand&rsquo; as they are direct skills. One movement leads directly to the next.</p>
                        <p>Whereas in &lsquo;hips, hips, hips&rsquo; we are working on lots of different hip movements within a single chapter.</p>
                        <p>We of course tried to order the exercises in a way that makes the most logical sense although there are going to be times where you level up and actually find the exercise easier.</p>
                        <p>&lsquo;Level up&rsquo; once you fully understand and can do the movement correctly for the given time.</p>
                        <p>There is also nothing wrong with leveling up to see what the next exercise is. Worst case, it&rsquo;s too challenging, &amp; then simply level back down again.</p>
                        <p>The key with any exercise is as follows: Does this challenge me?</p>
                        <p>If you&rsquo;re finding the exercise challenging and you&rsquo;re learning about your body, you&rsquo;re in the right place, no matter where in the chapter it comes up.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('14')}" @click="toggleBlock('14')">
                        <h2 class="standard-title heavy mt2">I&rsquo;ve finished my routine for the day can I do more?</h2>
                        <div>

                        <p>Absolutely you can! We&rsquo;d prefer you to be consistent for the month as opposed to
                            training more on one given day but if you&rsquo;d like to do both, here goes&hellip;
                            The process and options for adding a new routine are as follows:</p>

                        <h6>Repeat the same routine:</h6>
                        <p>This is a great option and the screen at the end of your routine will offer you this option if you wish to do that. If you miss that screen, no worries. Head to your dashboard and click &lsquo;START MY MOVES&rsquo; and you will repeat your day&rsquo;s routine.</p>
                        <h6>Change to a new routine:</h6>
                        <p><b>If you&rsquo;ve completed a routine from the library:</b></p>
                        <ul>
                            <li>Head to the page &lsquo;<a href="/calendar">view my calendar</a>&rsquo;</li>
                            <li>Toggle to &lsquo;schedule&rsquo; mode</li>
                            <li>Select todays routine in your calendar</li>
                            <li>Click the option &lsquo;remove from calendar&rsquo;</li>
                            <li>Head to your dashboard and press &lsquo;START MY MOVES&rsquo; &amp; you will follow a &lsquo;book moves&rsquo; routine</li>
                        </ul>
                        <p>or</p>
                        <p>Add a brand new routine from your private library onto today's date.</p>
                        <ul>
                            <li>Head to the page &lsquo;<a href="/calendar">view my calendar</a>&rsquo;</li>
                            <li>Toggle to &lsquo;schedule&rsquo; mode</li>
                            <li>Select a routine from the list</li>
                            <li>Place this on today's date</li>
                            <li>Head to your dashboard and press &lsquo;START MY MOVES&rsquo; &amp; you will follow your chosen routine</li>
                        </ul>

                        <h6>If you&rsquo;ve completed a &lsquo;book moves&rsquo; routine:</h6>
                        <ul>
                            <li>Head to the page &lsquo;<a href="/calendar">view my calendar</a>&rsquo;</li>
                            <li>Toggle to &lsquo;schedule&rsquo; mode</li>
                            <li>Select a routine from the list</li>
                            <li>Place this on today's date</li>
                            <li>Head to your dashboard and press &lsquo;START MY MOVES&rsquo; &amp; you will follow your chosen routine</li>
                        </ul>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('15')}" @click="toggleBlock('15')">
                        <h2 class="standard-title heavy mt2">What&rsquo;s the stretch challenge table?</h2>
                        <div>

                        <p>The stretch challenge starts on the 1st of each month and you will automatically enter it by completing your daily moves. The league table is composed of all participants that are completing their daily moves that month whether that be &lsquo;book moves&rsquo; or routines from the library.</p>
                        <p>As we have participants using the table in all countries, the table updates at 12:00 GMT each day. If you complete your daily moves before it&rsquo;s had a chance to go &lsquo;around the world&rsquo; then you will see a &lsquo;+1&rsquo; to let you know that we have registered your score. You can add yourself a profile picture or opt out of the stretch challenge table in your settings.</p>
                        <p>Each day you complete a routine, whether that is the &lsquo;book moves&rsquo; or a &lsquo;library routine&rsquo; you will get a ✅ on your calendar and be awarded one stretch coin.</p>
                        <p>We also give bonus stretch coins for ALL participants that are in the top three places.</p>
                        <p>For example, if it&rsquo;s January and you complete either 29, 30 or 31 days that month you will be awarded bonus coins which will appear at the top of your dashboard beside your name.</p>
                        <p>ALL 1st places = 100 coins</p>
                        <p>ALL 2nd places = 50 coins</p>
                        <p>ALL 3rd places = 30 coins</p>
                        <p>You can use your coins to either get discounts on merchandise &lsquo;subject to availability&rsquo; or you can use your coins for discounts on membership.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('16')}" @click="toggleBlock('16')">
                        <h2 class="standard-title heavy mt2">I&rsquo;m following the &lsquo;book moves&rsquo; &amp; prefer not to be working on one of the chapters, can I hide it?</h2>
                        <div>

                        <p>Based on your unique quiz answers, we will hide some of the chapters of the book. For example if you:</p>
                        <ul>
                            <li>Only want to do strength moves</li>
                            <li>Only want to do flexibility moves</li>
                            <li>Prefer not to do upside-down exercises</li>
                        </ul>
                        <p>You can also do this manually. If for any reason, you feel a particular chapter doesn&rsquo;t work for you, follow this process:</p>
                        <ul>
                            <li>Head to the page  &lsquo;<a href="/builder">build my moves</a>&rsquo;</li>
                            <li>Find the chapter you&rsquo;d prefer not to include</li>
                            <li>Click the 👁 icon next to the chapter</li>
                        </ul>
                        <p>Once you have followed this process, you will no longer see any more exercises from that particular chapter come up in your routine again. You can remove and add back chapters at any time by reversing the above process.</p>
                        <p>If you&rsquo;d like to view all of the 9 chapters and 90 exercises from the book head to the page &lsquo;<a href="/chapters">browse the chapters</a>&rsquo;.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('17')}" @click="toggleBlock('17')">
                        <h2 class="standard-title heavy mt2">My screen is freezing when transitioning between the daily moves</h2>
                        <div>

                        <p>The Hub has around 95% coverage across all devices &amp; we always recommend you are on the latest update to get the best experience for autoplay on the daily &lsquo;book moves&rsquo;. On some older devices it may be possible that some freezing occurs when your specific device / browser doesn&rsquo;t accept autoplay. With our fallback system you will be notified when this is the case.</p>
                        <p>We also have two workarounds for this specific issue.</p>
                        <p>Your first option is to toggle between the HLS settings in your <a href="/account/settings">settings</a> to see if this helps. Your second option is to try another browser on your device. Google chrome seems to work the best for The Hub.</p>
                        <p>If the freezing still persists please email us with your device / browser &amp; operating system and we will be happy to help you, where we can.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('18')}" @click="toggleBlock('18')">
                        <h2 class="standard-title heavy mt2">I have an injury / painful area should I still exercise?</h2>
                        <div>

                        <p>We all have different reasons for joining this programme. One of those reasons could be to resolve an injury or pain within a particular area.</p>
                        <p>The Frampton Method is based on learning to move more in-line with how our bodies move naturally. Through this delicate and conscious process, our goal is to reduce pain and prevent future injuries and immobility.</p>
                        <p>The training process is working into those areas of the body that have become tight, weak or limited due to either; a lack of movement, other sports or exercise, or just through the way we live our modern lifestyles which have become more sedentary through chairs and technology.</p>
                        <p>Our training is a mixture of prehab and rehab which includes slow, considered and conscious movements which encourage us to listen to our bodies and look for limitations and immobile areas.</p>
                        <p>That being said. We are all different &amp; there are many different reasons for pain and injuries happening in the body. For this very reason we always recommend that you consult your doctor before participating in ANY exercise programme.</p>
                        <p>Once you have been cleared to participate in an exercise programme it&rsquo;s important that no matter the exercise or movement you are doing, that you listen to your body.</p>
                        <p>Never train in pain! If any exercise feels painful or &lsquo;feels wrong&rsquo; please do not continue.</p>
                        <p>When following the routines we are looking for a light sensation of either the feeling of stretch or the feeling of muscular burn. This training is about improvement over time. If we push though pain we will only cause further injuries, setting back our training. Through repetition and consistency, improvement will happen.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('19')}" @click="toggleBlock('19')">
                        <h2 class="standard-title heavy mt2">I am pre / post natal can I still follow the programme?</h2>
                        <div>

                        <p>We recommend you work more closely with a trainer who is pre/post natal qualified. Please feel free to rejoin our programme when you are cleared to restart regular training again.</p>

                        </div>
                    </section>

                    <section class="faq-block" :class="{open: open_blocks.includes('20')}" @click="toggleBlock('20')">
                        <h2 class="standard-title heavy mt2">I don&rsquo;t have &lsquo;the flexible body&rsquo; book do I need it to take part?</h2>
                        <div>

                        <p>A part of our programme is following the book &lsquo;The Flexible Body&rsquo; on video, if you choose that option within the quiz.</p>
                        <p>To do this, you do not need a physical copy of the book to take part, although reading through the book will give you a lot more theory around our training. It will also help you to understand more about The Frampton Methood and why we use the particular sets of exercises that are within your programme.</p>
                        <p>You can purchase a personally signed copy of the book &lsquo;The Flexible Body&rsquo; using stretch coins or any payment method in our &lsquo;<a href="/community/store">stretch
                            store</a>&rsquo; (subject to availability).</p>

                        </div>
                    </section>

    </section>

</template>

<script>

export default {

    data(){
        return {
            open_blocks: []
        }
    },
    mounted(){

    },
    methods: {
        toggleBlock(index){
            if(this.open_blocks.includes(index)){
                for(let i=0; i<this.open_blocks.length; i++){
                    if(this.open_blocks[i] === index) {
                        this.open_blocks.splice(i, 1);
                    }
                }
            }else {
                this.open_blocks.push(index);
            }
        }
    }

}

</script>

































